var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.open
      ? _c("div", { staticClass: "grm-menu-component" }, [
          _c("div", {
            staticClass: "grm-menu-outside",
            on: { click: _vm.onClickOutside },
          }),
          _c("div", { staticClass: "grm-menu-wrapper" }, [
            _c(
              "ul",
              { staticClass: "grm-menu" },
              _vm._l(_vm.menuList, function (item, i) {
                return _c(
                  "li",
                  { key: i, staticClass: "grm-menu-item", class: [item.type] },
                  [
                    item.type === "divider"
                      ? _c("div", { staticClass: "model-list-divider" })
                      : _c(
                          "button",
                          {
                            staticClass: "grm-menu-button",
                            class: [
                              _vm.textAlign,
                              { toggle: !!item.toggleStatus },
                              {
                                toggleOn:
                                  item.toggleStatus &&
                                  item.toggleStatus() === true,
                              },
                              {
                                toggleOff:
                                  item.toggleStatus &&
                                  item.toggleStatus() === false,
                              },
                              { disabled: item.disabled },
                            ],
                            style: _vm.itemStyle(item),
                            on: {
                              click: function ($event) {
                                return _vm.onClickItem($event, item)
                              },
                            },
                          },
                          [_vm._v(_vm._s(item.title))]
                        ),
                  ]
                )
              }),
              0
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }